import PropTypes from 'prop-types'
import * as React from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { setFrProUser } from '../../store/reducers/Users/users.js'
import Toasts from '../../Components/Toasts/Toasts.js'
// import TabList from './profile/TabList.jsx'
// import Contact from './profile/Contact.jsx'
import ImageSection from './profile/ImageSection.jsx'
import { ProfileMethods } from './profile/ProfileMethods.js'
// import FeaturesOfProfile from './profile/FeaturesOfProfile.jsx'
import NewFeaturesOfProfile from './profile/NewFeaturesOfProfile.jsx'
import NewTabList from './profile/NewTabList.jsx'
import { ProfileApis } from '../../API/Login/ProfileApi.js'
import { dispatch } from '../../store/reducers/persist.js'
// import ErrorHandle from '../../Components/ErrorHandle.js'
// import { ProfileApis } from '../../API/Login/ProfileApi.js'
// import { ProfileApis } from '../../API/Login/ProfileApi.js'

export default function NewProfilePage(props) {
    const mainPageUrl = localStorage.getItem('mainPageUrl');
    const { frProUser, followers, following, buddyList } = useSelector(
        (state) => state?.Users
    )
    const { state } = useLocation()
    const [toasts, setToasts] = React.useState(null)
    let viewOthers = state?.viewOthers || false
    const [coverPhoto, setCoverPhoto] = React.useState('')
    const tabData = {
        ariaOrientation: 'horizontal',
        tabListData: [
            {
                id: 'About',
                tabName: 'About',
            },
            {
                id: 'PersonalDetails',
                tabName: 'Personal details',
            },
        ]
    }
    // const viewProfileTagLine = () => {
    //     let loogedInUser = JSON.parse(localStorage.getItem('user'))
    //     // let token = {
    //     //   fre8ProAccessToken:
    //     //     frProUser?.fre8ProAccessToken || loogedInUser?.fre8ProAccessToken,
    //     // }
    //     let userProfileImgObj = {
    //         fre8ProAccessToken: frProUser?.fre8ProAccessToken || loogedInUser?.fre8ProAccessToken,
    //         userId: frProUser?.userId,
    //         profileId: frProUser?.profileId,
    //         businessId: "",
    //         page: 1,
    //         size: 10,
    //         id: "",
    //         clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
    //     }
    //     ProfileApis.viewProfileTag(userProfileImgObj)
    //         .then((res) => {
    //             console.log('-------res?.data----> viewProfileTag --->', res?.data)
    //         })
    //         .catch((err) => {
    //             console.log('error', err)
    //             let customMessage = 'User profile image update failed'
    //             let type = 'User Information'
    //             let color = 'red'
    //             ErrorHandle(err, setToasts, customMessage, type, color)
    //         })
    // }

    // const getUserPersonalDetailsView = () => {
    //     let mobileNumberObj = {
    //         fre8ProAccessToken: frProUser?.fre8ProAccessToken,
    //         viewerUserId: frProUser?.userId,
    //         targetUserId: frProUser?.userId,
    //         operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
    //         operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
    //         clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
    //     }
    //     ProfileApis.getUserPersonalDetails(mobileNumberObj)
    //         .then((res) => {
    //             // Correct way to merge the objects
    //             setPersonalDetails(res?.data)
    //             // return setUpdatedFrProUserObj({
    //             //   ...frProUser,
    //             //   profileImages: res?.data?.defaultProfileImageList[0],
    //             // })
    //             // setMobilePrimaryNumber(res?.data)
    //         })
    //         .catch((err) => {
    //             console.debug('Mobile number not Available', err)
    //         })
    // }

    // React.useEffect(() => {
    //     getUserPersonalDetailsView()
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [])

    const getUserCoverPhotos = () => {
        let coverPhotoSelf = {
            fre8ProAccessToken: frProUser?.fre8ProAccessToken,
            requestId: "",
            serviceId: "",
            fre8ProLanguage: "",
            userAgent: "",
            userIpAddress: "",
            requestIncomingTime: "",
            userId: frProUser?.userId,
            profileId: frProUser?.profileId,
            coverPhotoId: "",
            imgOriginalName: "",
            imgGeneratedName: "",
            description: "",
            uploadedAt: "",
            uploadedAtString: "",
            coverPhotoUrl: "",
            coverPhotoUrlList: [
                ""
            ],
            coverPhotoUrls: {
                additionalProp1: "",
                additionalProp2: "",
                additionalProp3: ""
            },
            operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
            operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
            clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE

        }
        ProfileApis.getUserCoverPhotoSelf(coverPhotoSelf)
            .then((res) => {
                // Correct way to merge the objects
                dispatch(
                    setFrProUser({
                        frProUser: {
                            ...frProUser,
                            coverPhoto: res?.data.coverPhotoUrlList[0]
                        },
                    })
                )
                setCoverPhoto(res?.data.coverPhotoUrlList[0])
                // setMobilePrimaryNumber(res?.data)
            })
            .catch((err) => {
                console.debug('Cover photo not Available', err)
            })
    }

    React.useEffect(() => {
        getUserCoverPhotos()
        // viewProfileTagLine()
        if (state?.item?.viewOthers) {
            // getOtherUserProfile();
            console.log('Loading getOtherUserProfile')
        } else {
            if (mainPageUrl) {
                ProfileMethods.getUserProfileImage(frProUser, setFrProUser, setToasts)
                ProfileMethods.getFollowersList(frProUser, setToasts)
                ProfileMethods.getFollowingList(frProUser, setToasts)
                ProfileMethods.getBuddiesList(frProUser, setToasts)
            }
        }

        // eslint-disable-next-line
    }, []) //eslint-disable-line react-hooks/exhaustive-deps


    return (
        <>
            <main className="main users chart-page p-0" id="skip-target">
                <div className="profile-bg">
                    <div className="cover-image">
                        {coverPhoto && <img src={coverPhoto} alt="cover-image" className="img-fluid w-100" style={{ objectFit: 'cover', height: "250px" }} />}
                        <div className="container-fluid">
                        </div>
                    </div>

                    <div className="container-fluid py-3">
                        <ImageSection
                            following={following || []}
                            followers={followers || []}
                            buddyList={buddyList || []}
                            viewOthers={viewOthers}
                        />
                        <div className="row">
                            <div className="col-md-12">
                                <NewTabList tabData={tabData} />
                                {/* <Contact /> */}
                            </div>
                        </div>
                        {/* subSection */}
                        <NewFeaturesOfProfile
                            following={following || []}
                            followers={followers || []}
                            buddyList={buddyList || []}
                        />
                        {/* </div> */}
                    </div>
                </div>
            </main>
            {toasts && <Toasts toastsList={toasts} />}
            { }
        </>
    )
}

NewProfilePage.propTypes = {
    loading: PropTypes.bool,
}